export const SIDE_NAV_DASHBOARD = {
    name: "dashboard",
    label: "CONTENT.SIDEBAR.DASHBOARD",
    Icon: "Dashboard",
    description: "CONTENT.SIDEBAR.DASHBOARD-DESCRIPTION",
    subItems: [
        {
            name: 'panel',
            label: 'CONTENT.SIDEBAR.PANEL',
            Icon: 'Dashboard',
            to: '/',
            tag: 'DASHBOARD_VIEW',
            order: 11
        },
        {
            name: 'monitoring',
            label: 'CONTENT.SIDEBAR.MONITORING',
            Icon: 'Monitoring',
            to: '/dashboard/monitoring',
            tag: 'MONITORING_VIEW',
            order: 12
        },
        {
            name: 'alerts',
            label: 'CONTENT.SIDEBAR.ALERTS',
            Icon: 'Alert',
            to: '/dashboard/alerts',
            tag: 'ALERTS_VIEW',
            order: 13
        }
    ],
    to: "/dashboard",
    tag: 'DASHBOARD_VIEW',
    order: 1
}

export const SIDE_NAV_AUTOMSTORE = {
    name: 'store',
    label: 'CONTENT.SIDEBAR.STORE',
    Icon: 'Store',
    description: "CONTENT.SIDEBAR.STORE-DESCRIPTION",
    subItems: [
        {
            name: 'autom-store',
            label: 'CONTENT.SIDEBAR.AUTOM-STORE',
            Icon: 'AutomStore',
            to: '/store/autom',
            tag: 'AUTOMSTORE_VIEW',
            order: 21
        },
        {
            name: 'library-store',
            label: 'CONTENT.SIDEBAR.LIBRARY-STORE',
            Icon: 'LibraryStore',
            to: '/store/library',
            tag: 'LIBRARYSTORE_VIEW',
            order: 22
        }
    ],
    tag: 'AUTOMSTORE_VIEW',
    order: 2
}

export const SIDE_NAV_MYENVIRONMENT = {
    name: 'my-environment',
    label: 'CONTENT.SIDEBAR.MY-ENVIRONMENT',
    Icon: 'MyEnvironment',
    description: "CONTENT.SIDEBAR.MY-ENVIRONMENT-DESCRIPTION",
    subItems: [
        {
            name: "orchestrator",
            label: "CONTENT.SIDEBAR.ORCHESTRATOR",
            Icon: "Orchestrator",
            to: "/my-environment/orchestrator",
            tag: 'ORCHESTRATOR_VIEW',
            order: 31,
            addOn: true
        },
        {
            name: "my-mates",
            label: "CONTENT.SIDEBAR.MY-MATES",
            Icon: "MyMates",
            to: "/my-environment/my-mates",
            tag: 'MYMATES_VIEW',
            order: 32
        },
        {
            name: "autom-list",
            label: "CONTENT.SIDEBAR.AUTOMS",
            Icon: 'Automs',
            to: "/my-environment/autom-list",
            tag: 'CUSTOMAUTOMS_VIEW',
            order: 33
        },
        {
            name: "libraries",
            label: "CONTENT.SIDEBAR.LIBRARIES",
            Icon: 'Libraries',
            to: "/my-environment/libraries",
            tag: 'LIBRARIES_VIEW',
            order: 34
        }
    ],
    tag: 'MYENVIRONMENT_VIEW',
    order: 3
}

export const SIDE_NAV_AUTOMS = {
    name: "autom-new",
    label: "CONTENT.SIDEBAR.CREATE-AUTOM",
    Icon: "CreateAutom",
    to: "/autom-new",
    tag: 'CUSTOMAUTOMS_CREATE',
    additionalClass: ['pulse-white'],
    order: 4
}

export const SIDE_NAV_MANAGEMENT = {
    name: "management",
    label: "CONTENT.SIDEBAR.MANAGEMENT",
    Icon: "Management",
    description: "CONTENT.SIDEBAR.MANAGEMENT-DESCRIPTION",
    subItems: [
        {
            name: "user-management",
            label: "CONTENT.SIDEBAR.USER-MANAGEMENT",
            Icon: 'UserManagement',
            thirdLevelItems: [
                {
                    name: "users",
                    label: "CONTENT.SIDEBAR.USERS",
                    Icon: 'UserManagement',
                    to: "/management/user-management/users",
                    tag: 'USERMANAGEMENT_VIEW',
                    order: 511
                },
                {
                    name: "roles",
                    label: "CONTENT.SIDEBAR.ROLES",
                    Icon: 'RoleManagement',
                    to: "/management/user-management/roles",
                    tag: 'ROLEMANAGEMENT_VIEW',
                    order: 512
                }
            ],
            to: "/management/user-management/users",
            tag: 'USERMANAGEMENT_VIEW',
            order: 51
        },
        {
            name: 'vault',
            label: "CONTENT.SIDEBAR.VAULT",
            Icon: 'Vault',
            thirdLevelItems: [
                {
                    name: "app-credentials",
                    label: "CONTENT.SIDEBAR.APP-CREDENTIALS",
                    Icon: 'AppCredentials',
                    to: "/management/vault/app-credentials",
                    tag: 'APPCREDENTIALS_VIEW',
                    order: 521
                },
                {
                    name: "custom-credentials",
                    label: "CONTENT.SIDEBAR.CUSTOM-CREDENTIAL",
                    Icon: 'CustomCredentials',
                    to: "/management/vault/custom-credentials",
                    tag: 'CONNECTION_VIEW',
                    order: 522
                }
            ],
            to: '/management/vault/app-credentials',
            tag: 'VAULT_VIEW',
            order: 52
        },
        {
            name: 'webhook-api',
            label: "CONTENT.SIDEBAR.WEBHOOK-API",
            Icon: 'WebhookApi',
            thirdLevelItems: [
                {
                    name: 'webhook-trigger-rule',
                    label: 'CONTENT.SIDEBAR.WEBHOOK-TRIGGER-RULE',
                    Icon: 'WebhookTriggerRule',
                    to: '/management/webhook-api/webhook-trigger-rule',
                    tag: 'WEBHOOKAPITRIGGERRULE_VIEW',
                    order: 531
                },
                {
                    name: 'api-trigger-rule',
                    label: 'CONTENT.SIDEBAR.API-TRIGGER-RULE',
                    Icon: 'APITriggerRule',
                    to: '/management/webhook-api/api-trigger-rule',
                    tag: 'WEBHOOKAPITRIGGERRULE_VIEW',
                    order: 532,
                    disabled: true,
                    comingSoon: true
                }
            ],
            to: '/management/webhook-api/webhook-trigger-rule',
            tag: 'WEBHOOKAPITRIGGERRULE_VIEW',
            order: 53
        },
        {
            name: 'alert-management',
            label: "CONTENT.SIDEBAR.ALERT-MANAGEMENT",
            Icon: 'AlertManagement',
            thirdLevelItems: [
                {
                    name: 'alert-profile',
                    label: 'CONTENT.SIDEBAR.ALERT-PROFILE',
                    to: '/management/alert-management/alert-profile',
                    tag: 'ALERTPROFILE_VIEW',
                    order: 541
                },
                {
                    name: 'actioneer-profile',
                    label: 'CONTENT.SIDEBAR.ACTIONEER-PROFILE',
                    to: '/management/alert-management/actioneer-profile',
                    tag: 'ACTIONEERPROFILE_VIEW',
                    order: 542
                }
            ],
            to: '/management/alert-management/alert-profile',
            tag: 'ALERTMANAGEMENT_VIEW',
            order: 54
        },
        {
            name: 'queue-pool',
            label: 'CONTENT.SIDEBAR.QUEUE',
            Icon: 'Queue',
            to: '/management/queue-pool',
            tag: 'QUEUEPOOL_VIEW',
            order: 55
        },
        {
            name: 'approvements',
            label: 'CONTENT.SIDEBAR.APPROVEMENTS',
            Icon: 'Approvements',
            to: '/management/approvements',
            tag: 'APPROVEMENTS_VIEW',
            order: 56
        },
        {
            name: 'global-announcement',
            label: 'CONTENT.SIDEBAR.GLOBAL-ANNOUNCEMENT',
            Icon: 'Notification',
            to: '/management/global-announcement',
            tag: 'GLOBALANNOUNCEMENT_VIEW',
            order: 57
        }
    ],
    tag: "USERMANAGEMENT_VIEW",
    order: 5
}
export const SIDE_NAV_NOTIFICATION = {
    name: "notification",
    label: "CONTENT.SIDEBAR.NOTIFICATION",
    Icon: "Notification",
    to: "",
    tag: 'NOTIFICATION_VIEW',
    order: 6
}
export const SIDE_NAV_SETTINGS = {
    name: 'settings',
    label: 'CONTENT.SIDEBAR.SETTINGS',
    Icon: 'Settings',
    tag: 'SETTINGS_VIEW',
    to: '/settings/general',
    thirdLevelItems: [
        {
            name: 'general',
            label: 'CONTENT.SIDEBAR.GENERAL',
            to: '/settings/general',
            disabled: true,
            tag: 'SETTINGS_VIEW',
            order: 71
        },
        {
            name: 'personalization',
            label: 'CONTENT.SIDEBAR.PERSONALIZATION',
            to: '/settings/personalization',
            tag: 'PERSONALIZATIONMANAGEMENT_VIEW',
            order: 72
        },
        {name: 'port', label: 'CONTENT.SIDEBAR.PORT', to: '/settings/port', tag: 'PORTMANAGEMENT_VIEW', order: 73},
        {
            name: 'mail-server',
            label: 'CONTENT.SIDEBAR.MAIL-SERVER',
            to: '/settings/mail-server',
            tag: 'MAILSERVERMANAGEMENT_VIEW',
            order: 74
        },
        {
            name: 'updates',
            label: 'CONTENT.SIDEBAR.UPDATES',
            to: '/settings/updates',
            tag: 'UPDATEMANAGEMENT_VIEW',
            order: 75
        },
        {
            name: 'license',
            label: 'CONTENT.SIDEBAR.LICENSE',
            to: '/settings/license',
            tag: 'LICENSEMANAGEMENT_VIEW',
            order: 76
        }
    ],
    order: 7
}

export const SIDE_NAV_BAR_TOP_ITEMS = [
    SIDE_NAV_DASHBOARD,
    SIDE_NAV_AUTOMSTORE,
    SIDE_NAV_MYENVIRONMENT,
    SIDE_NAV_MANAGEMENT,
    // {
    //     name: "AILab",
    //     label: "CONTENT.SIDEBAR.AILAB",
    //     Icon: "AiIcon",
    //     to: "/ai-lab",
    //     tag: 'GLOBALVALUES_VIEW'
    // },
];

export const SIDE_NAV_BAR_BOTTOM_ITEMS = [
    SIDE_NAV_AUTOMS,
    SIDE_NAV_NOTIFICATION,
    SIDE_NAV_SETTINGS,
];
